export default {
  title: "Bankaccounts",

  view: {
    noItems: {
      title: "No bank accounts",
      text: "Click to add a bank account.",
    },
  },

  input: {
    title: "{{action}} bankaccount",
    bank: {
      label: "Bank",
    },
    holder: {
      label: 'Name',
    },
    iban: {
      label: "IBAN",
    },
    swift: {
      label: "SWIFT/BIC",
    },
  },

  api: {
    error: {
      bankAccount: {
        found: "Bankaccount already exists",
      },
    },
  },
}
